import adms_ap_v201_rdf_schema from '../../semantic/adms-ap_v2.01_rdf_schema.ttl.js';

const N3 = require('n3');
const { DataFactory } = N3;
const { namedNode } = DataFactory;

const labelPredicate = namedNode('http://www.w3.org/2000/01/rdf-schema#label');
const subClassOf = namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf');
/**
 * Специальный класс для обработки онтологии ADMS
 */

class AdmsOntologyHelper {

	constructor() {
    const parser = new N3.Parser();
		this.storeADMS = new N3.Store();
    this.storeADMS.addQuads(parser.parse(adms_ap_v201_rdf_schema));
	};


  /** Распрарсить текст, который получен запросом SKSAOntologRequest */
  parseSKSAOntology(content){
    let ttlText = content;
    if (typeof ttlText === "string" && ttlText.startsWith('"') && ttlText.endsWith('"')) {
      ttlText = JSON.parse(content);
    };
    const parser = new N3.Parser();
		const storeSKSA = new N3.Store();
    parser.parse(ttlText, (error, quad) => {
      
      if (error) {
        console.error("AdmsOntologyHelper.js Parsing SKSA Ontology error", error);
        return;
      }
      if (quad) {
        storeSKSA.addQuad(quad);
        this.storeADMS = storeSKSA;        
      } else {
        console.log("Finish. Store size = ", storeSKSA.size);
      }
    });
  };
  /** Возвращает список свойств, которые есть у типа.
   * Определяется по значению domain у типа.
   * Если  rdfType равен undefined, то возвращается список всех свойств 
   */
  getProperties(rdfType, purpose=undefined) {
      const quads = (rdfType==undefined) 
        ? 
        this.storeADMS.getQuads(null, namedNode('http://www.w3.org/2000/01/rdf-schema#domain'), null)
        :
        this.storeADMS.getQuads(null, namedNode('http://www.w3.org/2000/01/rdf-schema#domain'), namedNode(rdfType));
      return quads.map(quad => quad.subject.id);
  }

  /** Возвращает true, если свойство является аннотирующем (т.е. имеет многоязычную поддержку). 
   * Определяется, что его тип или owl:AnnotationProperty или owl:DatatypeProperty
   */  
  isAnnotationProperty(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris.includes('http://www.w3.org/2002/07/owl#AnnotationProperty');    
  }
  /** Возвращает true, если свойство является литеральным. 
   * Определяется, что его тип или owl:AnnotationProperty или owl:DatatypeProperty
   */  
  isLiteralProperty(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris.includes('http://www.w3.org/2002/07/owl#AnnotationProperty') || iris.includes('http://www.w3.org/2002/07/owl#DatatypeProperty');
    //http://www.w3.org/2002/07/owl#AnnotationProperty
  }

  /** Возвращает true, если свойство является ссылочным. 
   * Определяется, что его тип или owl:ObjectProperty
   */  
  isObjectProperty(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
    const iris = quads.map(quad => quad.object.id);
    return iris.includes('http://www.w3.org/2002/07/owl#ObjectProperty');
  }

  /** */
  getRanges(iriProperty){
    const quads =this.storeADMS.getQuads(namedNode(iriProperty), namedNode('http://www.w3.org/2000/01/rdf-schema#range'), null);
    const iris = quads.map(quad => quad.object.id);
    //console.log("AdmsOntologyHelper.js getRanges", iriProperty, quads, iris);
    return iris;
  }


    /**
   * Возвращает URI всех подклассов для заданного URI класса.
   * По умолчанию возвращает все вложенные подклассы рекурсивно.
   *
   * @param {string} classURI URI класса, для которого ищем подклассы
   * @param {boolean} recursive искать ли подклассы рекурсивно
   * @returns {string[]} массив URI подклассов
   */
  getSubClasses(classURI, recursive = true) {

    const subClassOf = namedNode('http://www.w3.org/2000/01/rdf-schema#subClassOf');

    const result = new Set();
    const visited = new Set();

    const findSubClasses = (parentURI) => {
      if (visited.has(parentURI)) return;
      visited.add(parentURI);

      const quads = this.storeADMS.getQuads(null,subClassOf,namedNode(parentURI));

      quads.forEach(quad => {
        const childURI = quad.subject.id;
        if (!result.has(childURI)) {
          result.add(childURI);
          if (recursive) findSubClasses(childURI);          
        }
      });
    };

    findSubClasses(classURI);

    return Array.from(result);
  }


  /** 
   * Возвращает URI родительских классов для заданного URI класса.
   * Например, если A rdfs:subClassOf B, то для A вернёт B.
   */
  getSuperClasses(classURI, recursive = true) {
    

    const result = new Set();
    const visited = new Set();

    const findSuperClasses = (childURI) => {
      if (visited.has(childURI)) return;
      visited.add(childURI);

      const quads = this.storeADMS.getQuads(
        namedNode(childURI),
        subClassOf,
        null
      );

      quads.forEach((quad) => {
        if (!quad.object || quad.object.termType !== 'NamedNode') return;

        const parentURI = quad.object.id;

        if (!result.has(parentURI)) {
          result.add(parentURI);

          if (recursive) {
            findSuperClasses(parentURI);
          }
        }
      });
    };

    findSuperClasses(classURI);

    return Array.from(result);
  }


  getLabel(iri, lang = undefined) {
    if (!iri) return null;
    

    const quads = this.storeADMS.getQuads(namedNode(iri), labelPredicate, null );

    if (!quads || quads.length === 0) return null;

    const literals = quads
      .map((quad) => quad.object)
      .filter((object) => object && object.termType === 'Literal');

    if (literals.length === 0) return null;

    if (lang) {
      const langLiteral = literals.find((literal) => literal.language === lang);

      if (langLiteral) {
        return langLiteral.value;
      }
    }

    const defaultLiteral = literals.find((literal) => !literal.language);

    if (defaultLiteral) 
      return defaultLiteral.value;    

    return literals[0]?.value || null;
  }
}

export default AdmsOntologyHelper;